export function cleanText(text: string) {
  return text
    .replace(/<\/?[^>]+(>|$)/g, "")
    .replace(/&nbsp;/g, "")
    .replace(/&amp;/g, "&");
}
